<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="dialog">
        <div class="flex flex-direction">
            <div class="title">{{ title }}</div>
            <div class="title_en">{{ title_en }}</div>
            <img alt="" class="icon" src="@/assets/images/icon_notice_tip.png">
            <div class="content margin-top-sm">
                <slot name="content"></slot>
            </div>
            <div class="dialog-operate flex align-center justify-center margin-top">
                <el-button class="btn max round" type="primary"  @click="submit">
                    {{confirmText}}
                </el-button>
                <el-button class="btn max round" type="info" @click="cancel">{{cancelText}}</el-button>
            </div>
        </div>

      <el-dialog
        width="500px"
        :visible.sync="innerVisible"
        :before-close="handleClose"
        append-to-body>
        <div class="title" slot="title">请选择闭店原因</div>
        <div>
          <el-select v-model="yuanyin" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in bidianOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="dialog-operate flex align-center justify-center margin-top">
          <el-button class="btn max round" type="primary"  @click="submitReason">
            确定
          </el-button>
        </div>
      </el-dialog>

    </el-dialog>
</template>

<script>


import {bidianOptions} from "@/utils/const";

export default {
    name: "StateTipDialog",
    components: {},
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '闭店通知'
        },
        title_en: {
            type: String,
            default: 'Closure Notice'
        },
        cancelText: {
            type: String,
            default: '取消操作'
        },
        confirmText: {
            type: String,
            default: '确认'
        },
        placeholder: {
            type: String,
            default: '请输入'
        },
        params: {
            type: [Object,String],
            default() {
                return {}
            }
        }
    },
    data() {
        return {
          innerVisible:false,
          bidianOptions:bidianOptions,
          yuanyin:'',
        }
    },
    computed: {},
    created() {

    },
    methods: {
        async submit() {
          if(this.params.is_lock == 1){
            this.innerVisible = true
          }else {
            this.$emit('watchState', this.params,this.yuanyin)
          }
        },

      async submitReason() {
        if(this.yuanyin == '') return this.$message.error('请选择闭店原因')
        this.handleClose()
        this.$emit('watchState', this.params,this.yuanyin)
      },

      handleClose(){
        this.innerVisible = false
      },

        cancel() {
            this.$emit('watchState',false)
        }
    },
    watch: {
        dialog() {

        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
    .el-textarea__inner{
        padding: 0;
        border: none;
    }
    .red {
        color: #f61919;
    }
    .state-tip{
        font-size: 16px;
        line-height: 26px;
        color: #64676d;
    }
    .el-dialog {
        width: 632px;
        background-image: linear-gradient(5deg,
            #ffffff 66%,
            #60aeff 100%);
        border-radius: 10px;
        padding: 16px 30px;

        .title {
            font-size: 22px;
            font-weight: 600;
            color: #2791ff;
        }

        .title_en {
            font-size: 17px;
            color: #2791ff;
        }

        .el-dialog__body {
            padding-top: 10px;
            position: relative;

            .icon {
                width: 103px;
                height: 113px;
                position: absolute;
                top: -30px;
                right: 20px;
            }
        }

        .content {
            background-color: #ffffff;
            border-radius: 10px;
            border: solid 1px #e4e4e4;
            padding: 25px;
            font-size: 17px;
            line-height: 30px;
            font-weight: 500;
            text-align: justify;
            color: #626469;
            position: sticky;
            z-index: 1;
            min-height: 166px;
        }

        .link {
            color: #0b3792;
            font-size: 17px;
        }
    }
}
</style>
